import domReady from '@wordpress/dom-ready';
domReady(() => {
  const searchResults = document.querySelector('.search-results__container');
  const sidebarItems = document.querySelectorAll(
    '.search-results__sidebar__item'
  );

  const FWP = window.FWP || {};
  if (!searchResults || sidebarItems.length < 1) {
    return;
  }

  document.addEventListener('facetwp-refresh', function () {
    searchResults.classList.add('loading');
  });
  document.addEventListener('facetwp-loaded', function () {
    const filter = FWP.facets.main_search_filters[0];
    const slug = filter || 'all';

    sidebarItems.forEach((sidebarItem) => {
      const sidebarItemCategory = sidebarItem.getAttribute('data-category');
      if (sidebarItemCategory !== slug) {
        sidebarItem.classList.add('hidden');
      } else {
        sidebarItem.classList.remove('hidden');
      }
    });
    const mainSearchQuery = document.getElementById('main-search-query-text');
    if (mainSearchQuery) {
      mainSearchQuery.textContent = FWP.facets.main_search || '';
    }
    searchResults.classList.remove('loading');
  });
});
